document.addEventListener("DOMContentLoaded",function()
{

    if(!sessionStorage.getItem("display"))
    {

        sessionStorage.setItem("display","default");

    }


    let displayProducts = sessionStorage.getItem("display");


    let collectionDisplay = document.querySelectorAll(".switch button");
    let collectionColumns = document.querySelector(".product-parent .product-grid");

    console.log(collectionColumns);

    if(collectionColumns)
    {


        collectionColumns.className = "";
        collectionColumns.classList.add("product-grid",displayProducts);

        collectionDisplay.forEach(el=>{


            console.log(el);

            el.addEventListener("click",function(e){

                e.preventDefault();

                console.log("CLICK");
                let currentDisplay = "";

                if(el.classList.contains("twocol"))
                {

                    currentDisplay = "two";


                }else if(el.classList.contains("defaultcol"))
                {

                    currentDisplay = "default";

                }else if(el.classList.contains("singlecol"))
                {

                    currentDisplay = "single";   

                }

                console.log(currentDisplay);

                if(currentDisplay)
                {

                    collectionColumns.className = "";
                    sessionStorage.setItem("display",currentDisplay);
                    displayProducts = sessionStorage.getItem("display");
                    collectionColumns.classList.add("product-grid",displayProducts);

                }



            });


        });

        
    }


});